var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMxnet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.04 61.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".mxnet-1{fill:#3997d1;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mxnet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "mxnet-1",
    d: "M29.79,0C15.26.51-.68,12.68,0,32.25A30.65,30.65,0,0,0,31.09,61.62C47.5,62.08,62.47,47.88,62,30A31.22,31.22,0,0,0,29.79,0ZM55.57,44.4c-3.89,0-7.78,0-11.67,0-.95,0-1.8-.14-1.83-1.35,0-1-.25-2.21,1.31-2.45a2.13,2.13,0,0,0,2-2.3c0-3.94,0-7.88-.09-11.81,0-1.5,0-3.37-1.75-4.05s-3.46.23-4.8,1.43c-2,1.81-3.43,3.91-3.24,6.85.15,2.42.07,4.87,0,7.31,0,1.37.39,2.32,1.85,2.57s1.26,1.47,1.24,2.5c0,1.24-.94,1.3-1.86,1.3H26.2c-.94,0-1.81-.13-1.83-1.35,0-1-.27-2.21,1.3-2.44s2.06-1.2,2-2.66c0-3.75.06-7.5-.05-11.25,0-1.58,0-3.51-1.77-4.23s-3.56.18-5,1.44c-2.19,2-3.6,4.25-3.36,7.38.16,2.17,0,4.37,0,6.56,0,1.41.47,2.47,2,2.72S20.94,42,20.92,43c0,1.21-.83,1.38-1.8,1.38-3.82,0-7.65,0-11.48,0-1.07,0-1.86-.23-1.84-1.53,0-1.09-.11-2.19,1.48-2.28,2-.13,2.79-1.24,2.75-3.23C10,33.17,10,29,10,24.79c0-1.8-.61-2.91-2.48-3.06-1.65-.13-1.84-1.16-1.74-2.49S7,17.82,8,17.82c2.39,0,4.78.08,7.15,0,1.9-.09,2.69.61,2.47,2.5A10.35,10.35,0,0,0,17.72,22c8.23-6.36,13.37-6.24,17.5.23,1.32-1,2.56-2.15,4-3.06a10.77,10.77,0,0,1,8.47-1.49A6.24,6.24,0,0,1,53,24.19c.08,4.32,0,8.63,0,12.94,0,2.65.26,3,2.89,3.45,1.52.23,1.54,1.14,1.53,2.27S56.65,44.4,55.57,44.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMxnet);
export default __webpack_public_path__ + "static/media/mxnet.dff3d3f54df3c93deec47dfbd6b8be9e.svg";
export { ForwardRef as ReactComponent };